import type { ExpandableContextType } from "./types";

import * as React from "react";

export const ExpandableContext = React.createContext<
  ExpandableContextType | undefined
>(undefined);
